<template>
  <div class="mm-page-main" v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div v-show="!show_info" class="page-header">
      <div class="page-title">銀行賬號管理</div>
      <div>
        <el-link @click="gotoruter('/AddBankAccount')" type="primary"><i class="el-icon-circle-plus"></i>添加銀行賬號</el-link>
      </div>
    </div>
    <search v-show="!show_info" :form="form" @submit="getdata"></search>

    <div v-show="!show_info" class="pagemain">
      <div class="mainheader">
        <div class="radio-group-box">
          <div class="radio-group-title">業務類別：</div>
          <div>
            <el-radio-group v-model="area" @change="getdata">
              <el-radio-button label="-1">全部</el-radio-button>
              <el-radio-button label="0">港幣</el-radio-button>
              <el-radio-button label="1">人民幣</el-radio-button>
              <el-radio-button label="2">外幣</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="downexcel">
          <el-link @click="exportExcel" icon="el-icon-download">下載EXCEL</el-link>
        </div>
      </div>

      <div class="pagetablebox">
        <el-table :data="bank_account_data" border :header-cell-style="{background:'#FAFAFA'}">
          <!-- <el-table-column prop="area" label="所屬地區" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">所屬地區</div>
              <div>{{scope.row.area==0?'香港':(scope.row.area==1?'中國':'海外')}}</div>
            </template>
          </el-table-column> -->
          <el-table-column prop="code" label="賬戶代碼" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">賬戶代碼</div>
              <div>{{scope.row.code}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="銀行賬戶" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">銀行賬戶</div>
              <div class="mm-text-right">
                <div>
                  <img height="20px" width="20px" :src="apiurl+scope.row.currency_thumb" />
                  <span style="margin:0 5px;">{{scope.row.currency_name}}</span>
                  <span>{{scope.row.currency_short_name}}</span>
                </div>
                <div>{{scope.row.bankinfo!=''?scope.row.bankinfo:scope.row.bankname}}</div>
                <div>{{scope.row.account_name}}</div>
                <div>{{addSpace(scope.row.account_num)}}</div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="bankname" label="銀行名稱" align="center" sortable>
						<template slot-scope="scope">
							<div class="phonecel">銀行名稱</div>
							<div>{{scope.row.bankinfo!=''?scope.row.bankinfo:scope.row.bankname}}</div>
						</template>
					</el-table-column>
					<el-table-column width="200px" prop="account_num" label="賬號號碼" align="center" sortable>
						<template slot-scope="scope">
							<div class="phonecel">賬號號碼</div>
							<span>{{addSpace(scope.row.account_num)}}</span>
						</template>
					</el-table-column> -->
          <!-- <el-table-column prop="account_name" label="賬戶持有人名稱" align="center" sortable>
						<template slot-scope="scope">
							<div class="phonecel">賬戶持有人名稱</div>
							<span>{{scope.row.account_name}}</span>
						</template>
					</el-table-column> -->

          <el-table-column prop="balance" label="餘額" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">餘額</div>
              <div>{{tomoney(scope.row.balance)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="deal_num" label="交易次數" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">交易次數</div>
              <div>{{scope.row.deal_num}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="day_limit" label="今日流量" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">今日流量</div>
              <div>{{tomoney(scope.row.day_limit)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="day_limit" label="今日剩餘流量" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">今日剩餘流量</div>
              <div>{{tomoney(scope.row.day_limit)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="month_limit" label="本月流量" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">本月流量</div>
              <div>{{tomoney(scope.row.month_limit)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="month_limit" label="本月剩餘流量" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">本月剩餘流量</div>
              <div>{{tomoney(scope.row.month_limit)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="狀態" align="center" sortable>
            <template slot-scope="scope" sortable>
              <div class="phonecel">狀態</div>
              <el-switch disabled="" v-model="scope.row.status" active-text="啟用" inactive-text="禁用"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90px" align="center">
            <template slot-scope="scope">
              <div class="phonecel">操作</div>
              <el-button @click="account_id=scope.row.id;show_info=true;" size="mini">編輯</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-bottom">
        <div>
          Total: {{pager.p_count}}個賬號

        </div>
        <div></div>
        <div>
          <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
          </el-pagination>
        </div>
      </div>

    </div>

    <div v-if="show_info">
      <div class="mm-row mb15 flex-center">
        <div class="page-title">編輯銀行賬號</div>
        <el-button type="primary" @click="show_info=false;edit_info=false;getdata()">返回<i class="el-icon-left"></i></el-button>
      </div>
      <editbankaccount :account_id="account_id"></editbankaccount>
    </div>

  </div>

</template>
<style lang="stylus" scoped></style>
<script>
import search from "./components/Search.vue";
import editbankaccount from "./components/EditBankAccount.vue";
import XLSX from 'xlsx';
export default {
  components: {
    search,
    editbankaccount
  },
  data () {
    return {
      form: {
        mso_id: 0,
        account_num: '',
        account_name: '',
        code: '',
        bankname: '',
        starttime: '',
        endtime: '',
        startbalance: '',
        endbalance: '',
        currency_id: '-1',
        status: '-1',
      },
      area: -1,
      bank_account_data: [],
      page: 1,
      pagesize: 10,
      pager: [],
      show_info: false,
      account_id: 0,
    };
  },
  methods: {
    exportExcel () {
      this.$confirm("確認下載EXCEL嗎？", '詢問', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.excel();
      }).catch(error => {
        console.log(error);
      });
    },
    excel () {
      let form = this.form;
      this.post('/api/bank/bank_account', {
        export_excel: 1,
        page: this.page,
        pagesize: this.pagesize,
        area: this.area,
        ...form
      }).then(response => {
        if (response.info.length > 0) {
          this.createExcel(response.info);
        } else {
          // 提醒信息
          this.$notify({
            message: '暫無相關數據',
            type: 'error',
            duration: 3000,
            offset: 160
          });
        }
      }).catch(error => { console.log(error) });
      return false;

    },
    createExcel (data) {
      //数据表格
      var table = [];
      table.push({
        A: "賬戶代碼",
        B: "創建日期",
        C: "賬戶號碼",
        D: "賬戶戶名",
        E: "銀行名稱",
        F: "餘額",
        G: "今日流量",
        H: "本月流量",
        I: "本地剩餘流量",
        J: "狀態",
      });
      data.forEach((item) => {
        let bankcode = item.bankcode;
        let account = item.account_num;
        let account_owner = item.account_name;
        let account_bank = item.bankinfo != '' ? item.bankinfo : item.bankname;
        let area = '';
        if (item.area == 0) {
          area = '港幣'; 
        } else if (item.area== 1) {
          area = '人民幣'; 
        }else if(item.area == 2){
          area = '外幣'; 
        }
        let date = item.date;

        let status = item.status==0?'啟用':'禁用';
        var row = {
          A: bankcode,
          B: date,
          C: account,
          D: account_owner,
          E: account_bank,
          F: item.balance,
          G: item.day_limit,
          H: item.limit_30,
          I: item.month_limit,
          J: status,
        };
        table.push(row);
      });
      //创建book
      var wb = XLSX.utils.book_new();
      //json转sheet
      var ws = XLSX.utils.json_to_sheet(table, { header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"], skipHeader: true });
      //设置列宽
      ws['!cols'] = [
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 25 },
        { width: 15 },
        { width: 10 }
      ];
      var timestamp = (new Date()).getTime();
      //sheet写入book
      XLSX.utils.book_append_sheet(wb, ws, "銀行賬號列表");
      //输出
      XLSX.writeFile(wb, "banklist" + timestamp + ".xlsx");
    },
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    gotoruter (name) {
      this.$router.push(name)
    },
    getdata () {
      let form = this.form;
      this.post('/api/bank/bank_account', {
        page: this.page,
        pagesize: this.pagesize,
        area: this.area,
        ...form
      }).then((res) => {
        res.info.map((v) => {
          if (v.status == 0) {
            v.status = true;

          } else if (v.status == 1) {
            v.status = false;
          }

        })
        this.bank_account_data = res.info;
        this.pager = res.pager;
      }).catch((err) => {

        console.log(err)
      })
    }

  },
  created () {
    this.mso_id = sessionStorage.getItem('mso_id');
    this.form.mso_id = sessionStorage.getItem('mso_id');
    this.getdata();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getdata();
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.pagetablebox {
  padding: 20px 0;
}

.radio-group-box {
  display: flex;
  align-items: center;
}
</style>
